export { PatientAdmissionsTab } from './PatientAdmissionsTab';
export { PatientConsumableTab } from './PatientConsumableTab';
export { PatientAllergyTab } from './PatientAllergyTab';
